import { makeStyles } from '@mui/styles';
import { Colors } from '../../../utils/color';

export default makeStyles((theme) => ({
  dialog_mask: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 2,
    background: Colors.EXTRA_GRAY,
  },
  dialog_container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: 25,
    zIndex: 3,
    // minHeight: 230,
    minWidth: 350,
    maxWidth: 350,
    background: theme.palette.dialog_background,
  },
  form_container: {
    marginTop: 25,
    display: 'flex',
    flexDirection: 'column',
  },
  form_label: {
    color: theme.palette.form_label,
  },
  form_input: {
    '&::placeholder': {
      color: theme.palette.input_placeholder,
    },
    backgroundColor: 'transparent',
    color: theme.palette.profile_title,
    '&:focus': {
      border: `1px solid ${theme.palette.input_border}`,
    },
  },
  form_input_container: {
    marginTop: 12,
  },
  add_button_container: {
    marginTop: 17,
  },
  add_button: {
    fontWeight: 600,
    backgroundColor: theme.palette.background_button,
    color: theme.palette.background_button_text,
    '&:hover': {
      backgroundColor: theme.palette.background_button,
    },
  },
  flexView: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 25,
  },
}));
